import { useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { AuthShell } from "@/pages/Login";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Loader2, MailCheck, ArrowLeft } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
    } catch {
      /* always show the same generic confirmation */
    }
    setLoading(false);
    setSent(true);
  };

  return (
    <AuthShell title="Forgot password" subtitle="We'll email you a secure reset link.">
      {sent ? (
        <div className="text-center space-y-4" data-testid="forgot-sent">
          <div className="h-14 w-14 rounded-2xl bg-emerald-100 dark:bg-emerald-900/40 flex items-center justify-center mx-auto">
            <MailCheck className="h-7 w-7 text-emerald-600" />
          </div>
          <p className="text-sm text-muted-foreground">
            If an account exists for <strong>{email}</strong>, we've sent a reset link. It expires in 1 hour — check your inbox (and spam folder).
          </p>
          <Link to="/login" className="inline-flex items-center gap-1.5 text-sm text-emerald-700 dark:text-emerald-400 font-semibold hover:underline" data-testid="back-to-login">
            <ArrowLeft className="h-4 w-4" /> Back to sign in
          </Link>
        </div>
      ) : (
        <>
          <form onSubmit={submit} className="space-y-4" data-testid="forgot-form">
            <div className="space-y-1.5">
              <Label htmlFor="email">Email</Label>
              <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@garden.com" required data-testid="forgot-email-input" />
            </div>
            <Button type="submit" disabled={loading} className="w-full bg-emerald-700 hover:bg-emerald-800 py-2.5" data-testid="forgot-submit-button">
              {loading && <Loader2 className="h-4 w-4 mr-2 animate-spin" />} Send reset link
            </Button>
          </form>
          <p className="text-xs text-muted-foreground mt-4 text-center">
            Signed up with Google? Use <Link to="/login" className="text-emerald-700 dark:text-emerald-400 font-medium hover:underline">Continue with Google</Link> instead — Google accounts don't have a password here.
          </p>
          <p className="text-sm text-muted-foreground mt-6 text-center">
            <Link to="/login" className="text-emerald-700 dark:text-emerald-400 font-semibold hover:underline" data-testid="forgot-back-login">Back to sign in</Link>
          </p>
        </>
      )}
    </AuthShell>
  );
}
